module.exports = __webpack_public_path__ + "static/assets/1d8b13b4a4913bad2bbac4ba322dbe87.png";